import { useState } from 'react'
import { Image } from 'components/shared/Image'
import { StyledTreatmentSlider } from './TreatementSlider.styles'
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react'
import 'swiper/css'
import ZonesSliderButton from './subcomponents/TreatmentSliderButton/TreatmentSliderButton'
import { useResolutions } from 'store/resolutions'

interface TreatmentSliderProps {
    images: string[]
    alt: string
}

const TreatmentSlider = ({ images, alt }: TreatmentSliderProps) => {
    const { isMobile, isTablet } = useResolutions()

    const [isPrevNavVisible, setIsPrevNavVisible] = useState(false)
    const [isNextNavVisible, setIsNextNavVisible] = useState(
        !isTablet && images.length > 1
    )

    const handleProgress = (_swiper: SwiperClass, progress: number) => {
        setIsPrevNavVisible(progress !== 0)
        setIsNextNavVisible(progress !== 1)
    }

    return images.length > 1 ? (
        <StyledTreatmentSlider direction="row">
            <Swiper
                spaceBetween={isMobile ? 12 : 8}
                slidesPerView={'auto'}
                onProgress={isTablet ? undefined : handleProgress}
            >
                <div slot="container-start">
                    {isPrevNavVisible && <ZonesSliderButton direction="prev" />}
                </div>

                {images.map((imageUrl, index) => (
                    <SwiperSlide key={index}>
                        <Image
                            src={imageUrl}
                            alt={alt}
                            width={[308, 360]}
                            height={[200, 240]}
                            borderRadius={8}
                        />
                    </SwiperSlide>
                ))}
                <div slot="container-end">
                    {isNextNavVisible && <ZonesSliderButton direction="next" />}
                </div>
            </Swiper>
        </StyledTreatmentSlider>
    ) : (
        <Image
            src={images[0]}
            alt={alt}
            width={'100%'}
            height={[200, 240]}
            borderRadius={8}
        />
    )
}

export default TreatmentSlider
